import { History } from "history";

import {
  CreateVerificationRequest,
  CreateVerificationResponse,
  ForgetPasswordRequest,
  ResetPasswordRequest,
  SigninRequest,
  SigninResponse,
  SignoutRequest,
  VerificationRequest,
  VerificationResponse,
} from "../../interfaces";

//#region Login

export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS: any = "LOGIN_SUCCESS";
export const LOGIN_ERROR: any = "LOGIN_ERROR";
export const RESET_LOGIN_FLAG: any = "RESET_LOGIN_FLAG";

export interface LoginAction {
  type: typeof LOGIN;
  payload: {
    request: SigninRequest;
    history: History;
  };
}

export interface LoginSuccessAction {
  type: typeof LOGIN_SUCCESS;
  payload: SigninResponse;
}

export interface LoginErrorAction {
  type: typeof LOGIN_ERROR;
  payload: any;
}
//#endregion

//#region logout
export const LOGOUT: any = "LOGOUT";
export const LOGOUT_USER_SUCCESS: any = "LOGOUT_USER_SUCCESS";
export const LOGOUT_USER_ERROR: any = "LOGOUT_USER_ERROR";

export interface LogoutAction {
  type: typeof LOGOUT;
  payload: {
    request: SignoutRequest;
    history: History;
  };
}

export interface LogoutSuccessAction {
  type: typeof LOGOUT_USER_SUCCESS;
  payload?: any;
}

export interface LogoutErrorAction {
  type: typeof LOGOUT_USER_ERROR;
  payload: any;
}

//#endregion

//#region Forget

export const FORGET_PASSWORD: any = "FORGET_PASSWORD";
export const FORGET_PASSWORD_SUCCESS: any = "FORGET_PASSWORD_SUCCESS";
export const FORGET_PASSWORD_ERROR: any = "FORGET_PASSWORD_ERROR";

export interface ForgetPasswordAction {
  type: typeof FORGET_PASSWORD;
  payload: {
    request: ForgetPasswordRequest;
    history: History;
  };
}

export interface ForgetPasswordSuccessAction {
  type: typeof FORGET_PASSWORD_SUCCESS;
  payload?: VerificationResponse;
}

export interface ForgetPasswordErrorAction {
  type: typeof FORGET_PASSWORD_ERROR;
  payload: any;
}

//#endregion

//#region Verify OTP

export const VERIFY_OTP: any = "VERIFY_OTP";
export const VERIFY_OTP_SUCCESS: any = "VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_ERROR: any = "VERIFY_OTP_ERROR";

export interface VerifyOTPAction {
  type: typeof VERIFY_OTP;
  payload: {
    request: VerificationRequest;
    history: History;
  };
}

export interface VerifyOTPSuccessAction {
  type: typeof VERIFY_OTP_SUCCESS;
  payload?: SigninResponse;
}

export interface VerifyOTPErrorAction {
  type: typeof VERIFY_OTP_ERROR;
  payload: any;
}

//#endregion

//#region Reset Password

export const RESET_PASSWORD: any = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS: any = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_ERROR: any = "RESET_PASSWORD_ERROR";

export interface ResetPasswordAction {
  type: typeof RESET_PASSWORD;
  payload: {
    request: ResetPasswordRequest;
    history: History;
  };
}

export interface ResetPasswordSuccessAction {
  type: typeof RESET_PASSWORD_SUCCESS;
  payload?: boolean;
}

export interface ResetPasswordErrorAction {
  type: typeof RESET_PASSWORD_ERROR;
  payload: any;
}

//#endregion

//#region Resend OTP

export const RESEND_OTP: any = "RESEND_OTP";
export const RESEND_OTP_SUCCESS: any = "RESEND_OTP_SUCCESS";
export const RESEND_OTP_ERROR: any = "RESEND_OTP_ERROR";

export interface ResendOTPAction {
  type: typeof RESEND_OTP;
  payload: {
    request: CreateVerificationRequest;
    history: History;
  };
}

export interface ResendOTPSuccessAction {
  type: typeof RESEND_OTP_SUCCESS;
  payload?: CreateVerificationResponse;
}

export interface ResendOTPErrorAction {
  type: typeof RESEND_OTP_ERROR;
  payload: any;
}

//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | LoginAction
  | LoginSuccessAction
  | LoginErrorAction
  | LogoutAction
  | LogoutSuccessAction
  | LogoutErrorAction
  | ForgetPasswordAction
  | ForgetPasswordSuccessAction
  | ForgetPasswordErrorAction
  | VerifyOTPAction
  | VerifyOTPSuccessAction
  | VerifyOTPErrorAction
  | ResetPasswordAction
  | ResetPasswordSuccessAction
  | ResetPasswordErrorAction;
